export const subtitles = {
    "1": {
        "startTime": 1.6400000000000001,
        "endTime": 8.83,
        "transcript": "Living a life that is not as hard, nor should... not a very difficult life.",
        "translation": "Living a life that is not as hard, nor should... not a very difficult life."
    },
    "2": {
        "startTime": 14.93,
        "endTime": 16.61,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "3": {
        "startTime": 16.985,
        "endTime": 21.295,
        "transcript": "Maa-i-rpak elitnautuukut, elitnaurvigluteng-llu.",
        "translation": "Now, we go to school, and there are schools."
    },
    "4": {
        "startTime": 24.075,
        "endTime": 29.475,
        "transcript": "Elitnauriyaraq tang cimilria, ayuqenrilria.",
        "translation": "You see, teaching has changed, not the same anymore."
    },
    "5": {
        "startTime": 29.73,
        "endTime": 35.93,
        "transcript": "Elitnauqerraallemni tayima Kass'atun qanerciigatellruunga.",
        "translation": "When I first went to school, I couldn't speak English."
    },
    "6": {
        "startTime": 36.235,
        "endTime": 41.695,
        "transcript": "Tau͡gken Kass'acetun qanerciigalnge'rma qanrucimalallruunga",
        "translation": "However, even though I couldn't speak English, I would be told"
    },
    "7": {
        "startTime": 42.12,
        "endTime": 51.42,
        "transcript": "Elitnaurviim-gguq nunautiini wall'u avatiini uitakuma Kass'aturrlainaq qalareskilii.",
        "translation": "They said that if I was on school grounds or around it, that I should only speak in English."
    },
    "8": {
        "startTime": 55.675,
        "endTime": 58.745,
        "transcript": "Tamana tuaten ayuqenrirtuq.",
        "translation": "That's not like that anymore."
    },
    "9": {
        "startTime": 58.995,
        "endTime": 63.065,
        "transcript": "Maa-i village-aanun ayagaaqamta",
        "translation": "Now, when we travel to villages"
    },
    "10": {
        "startTime": 67.805,
        "endTime": 78.335,
        "transcript": "School-ani-llu piaqama waten murilkurnaurtua elitnauristet elitnauriaqluteng tayima something called \"bilingual education.\"",
        "translation": "And when I go to schols, I would observe teachers teaching something called \"bilingual education.\""
    },
    "11": {
        "startTime": 84.725,
        "endTime": 96.495,
        "transcript": "Taringumatacimtun-llu tayima tuaten elitnaurvigni tamakunek elitnauritulini pitangqerraqan Yugtun-llu qaneryaramek tayima elitnauritulliniut.",
        "translation": "And from my understanding, when schools have those kinds of teachers, they apparently also teach how to speak Yup'ik."
    },
    "12": {
        "startTime": 98.625,
        "endTime": 102.235,
        "transcript": "Cumikarnaqsaaqvaa-llu tuaten pilliniata.",
        "translation": "We must may attention since they're doing that."
    },
    "13": {
        "startTime": 107.425,
        "endTime": 110.115,
        "transcript": "What about the schools today?",
        "translation": "What about the schools today?"
    },
    "14": {
        "startTime": 111.545,
        "endTime": 116.815,
        "transcript": "So much have changed since I first stepped into a classroom.",
        "translation": "So much have changed since I first stepped into a classroom."
    },
    "15": {
        "startTime": 117.585,
        "endTime": 122.425,
        "transcript": "At one point, although some of us are not able to speak English",
        "translation": "At one point, although some of us are not able to speak English"
    },
    "16": {
        "startTime": 123.34,
        "endTime": 130.92,
        "transcript": "We were actually prohibited in some instances from speaking our language.",
        "translation": "We were actually prohibited in some instances from speaking our language."
    },
    "17": {
        "startTime": 131.905,
        "endTime": 135.655,
        "transcript": "Yet, we didn't know how to speak English.",
        "translation": "Yet, we didn't know how to speak English."
    },
    "18": {
        "startTime": 139.485,
        "endTime": 144.385,
        "transcript": "Like I stated, so much have changed since that time.",
        "translation": "Like I stated, so much have changed since that time."
    },
    "19": {
        "startTime": 144.68,
        "endTime": 155.0,
        "transcript": "Today, throughout my travels throughout the region, I've seen something called \"bilingual education.\"",
        "translation": "Today, throughout my travels throughout the region, I've seen something called \"bilingual education.\""
    },
    "20": {
        "startTime": 155.075,
        "endTime": 161.505,
        "transcript": "It's my understanding that in these instances, that Yup'ik is taught",
        "translation": "It's my understanding that in these instances, that Yup'ik is taught"
    },
    "21": {
        "startTime": 161.625,
        "endTime": 171.815,
        "transcript": "And that Yup'ik, in some instances, is actually encouraged to be spoken on school grounds under those circumstances.",
        "translation": "And that Yup'ik, in some instances, is actually encouraged to be spoken on school grounds under those circumstances."
    },
    "22": {
        "startTime": 174.915,
        "endTime": 181.495,
        "transcript": "This is very encouraging because one of the basis of our society is our language.",
        "translation": "This is very encouraging because one of the basis of our society is our language."
    },
    "23": {
        "startTime": 189.58,
        "endTime": 190.78,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "24": {
        "startTime": 196.255,
        "endTime": 198.865,
        "transcript": "Umyuangcaqaqernaurtukut.",
        "translation": "Let us ponder for a moment."
    },
    "25": {
        "startTime": 204.905,
        "endTime": 209.525,
        "transcript": "Ca pininrua piniqapiggluni?",
        "translation": "What is the most powerful?"
    },
    "26": {
        "startTime": 217.97,
        "endTime": 219.07,
        "transcript": "Atam.",
        "translation": "Look."
    },
    "27": {
        "startTime": 222.525,
        "endTime": 229.515,
        "transcript": "Aperyarat, wall'u qaneryaraq. Waten wangkuta qaneryaraput piniqapigtuq.",
        "translation": "Words, or language. Our language is powerful."
    },
    "28": {
        "startTime": 235.435,
        "endTime": 240.725,
        "transcript": "Elitnauristeḿa iliit angutngurtellruuq.",
        "translation": "One of my teachers has become an old man."
    },
    "29": {
        "startTime": 242.755,
        "endTime": 245.175,
        "transcript": "Waten-llu qanruartelallruanga:",
        "translation": "And he used to tell me this:"
    },
    "30": {
        "startTime": 249.76,
        "endTime": 260.51,
        "transcript": "\"Kitaki, camek ilavet aperyaranek aturluni qalaruskaten niicugniurqina.\"",
        "translation": "\"Now, when our peer speaks to you with words, listen.\""
    },
    "31": {
        "startTime": 269.31,
        "endTime": 276.46,
        "transcript": "One of the strongest sources of force known to mankind is words.",
        "translation": "One of the strongest sources of force known to mankind is words."
    },
    "32": {
        "startTime": 279.24,
        "endTime": 288.02,
        "transcript": "This source of force is known to all the societies, although they may not be able to communicate with each other.",
        "translation": "This source of force is known to all the societies, although they may not be able to communicate with each other."
    },
    "33": {
        "startTime": 288.385,
        "endTime": 301.045,
        "transcript": "Yet, it's the very words, that is one of the strongest sources of force in the universe.",
        "translation": "Yet, it's the very words, that is one of the strongest sources of force in the universe."
    },
    "34": {
        "startTime": 303.12,
        "endTime": 309.39,
        "transcript": "Primarily because of the fact, when you say something using words",
        "translation": "Primarily because of the fact, when you say something using words"
    },
    "35": {
        "startTime": 310.16,
        "endTime": 318.49,
        "transcript": "What you have stated forever escapes through your mouth to the people.",
        "translation": "What you have stated forever escapes through your mouth to the people."
    },
    "36": {
        "startTime": 321.56,
        "endTime": 327.5,
        "transcript": "That's why I think one must be very careful in their use of words",
        "translation": "That's why I think one must be very careful in their use of words"
    },
    "37": {
        "startTime": 327.505,
        "endTime": 335.705,
        "transcript": "Because at some point, what you stated using words at some point may come back and haunt you.",
        "translation": "Because at some point, what you stated using words at some point may come back and haunt you."
    },
    "38": {
        "startTime": 346.95,
        "endTime": 348.19,
        "transcript": "Tuamta-llu",
        "translation": "And so"
    },
    "39": {
        "startTime": 350.145,
        "endTime": 362.945,
        "transcript": "Wangkuta ayagyualriani arcaqerluta makut ciuliaput iliini takaqeksaitaput.",
        "translation": "Especially we young people have sometimes not shown these elders respect."
    },
    "40": {
        "startTime": 363.52,
        "endTime": 367.96,
        "transcript": "Takarnaqsaaqut. Takarnaqeqapigcaaqut.",
        "translation": "They must be treated with respect. They must be treated with great respect."
    },
    "41": {
        "startTime": 371.915,
        "endTime": 384.105,
        "transcript": "Yuuyaram-wa qaillun-llu yuullerkaa, yuukumta pillerkamteńek qanrutetuyaaqaitkut.",
        "translation": "They tell us about the Yup'ik way of life, how one should life, and what we should do in our lives."
    },
    "42": {
        "startTime": 391.205,
        "endTime": 392.365,
        "transcript": "Atam.",
        "translation": "Look."
    },
    "43": {
        "startTime": 395.47,
        "endTime": 405.13,
        "transcript": "Camek qanrutetuitkut ikayuryugyaaqngamegtekut cakviussiyaagluta yuusqumanrilamegtekut.",
        "translation": "They tell us things because they want to help us, because they don't want us to struggle too much as we live."
    },
    "44": {
        "startTime": 407.555,
        "endTime": 411.205,
        "transcript": "Qanellrit-llu tayima takarnaqeqapiggluteng.",
        "translation": "And what they said deserves great respect."
    },
    "45": {
        "startTime": 416.135,
        "endTime": 427.495,
        "transcript": "Ciumuassiyaagluta piksailkumta, iliini-llu umyuaqeqa'aqluki alerquuteput yuukumta cakviussiyaagngaicugnarqukut.",
        "translation": "If we do not do things we're told not to do, and if we sometimes remember our instructions in our lives, we will not struggle too much."
    },
    "46": {
        "startTime": 431.85,
        "endTime": 433.45,
        "transcript": "What about respect?",
        "translation": "What about respect?"
    },
    "47": {
        "startTime": 438.005,
        "endTime": 440.525,
        "transcript": "We must respect our elders.",
        "translation": "We must respect our elders."
    },
    "48": {
        "startTime": 443.46,
        "endTime": 453.9,
        "transcript": "They alone are the people who can speak about life based on experiences of life.",
        "translation": "They alone are the people who can speak about life based on experieces of life."
    },
    "49": {
        "startTime": 460.275,
        "endTime": 467.055,
        "transcript": "When they're speaking about life based on experience of life, you cannot be any stronger.",
        "translation": "When they're speaking about life based on experience of life, you cannot be any stronger."
    },
    "50": {
        "startTime": 473.97,
        "endTime": 480.87,
        "transcript": "If we respect and listen to what they have to say",
        "translation": "If we respect and listen to what they have to say"
    },
    "51": {
        "startTime": 480.875,
        "endTime": 486.735,
        "transcript": "And perhaps remember a very little portion of what they have to say to us",
        "translation": "And perhaps remember a very little portion of what they have to say to us."
    },
    "52": {
        "startTime": 487.55,
        "endTime": 496.03,
        "transcript": "We might find that living this life will be a little bit easier to cope with.",
        "translation": "We might find that living this life will be a little bit easier to cope with."
    },
    "53": {
        "startTime": 497.635,
        "endTime": 503.25,
        "transcript": "Remember, when they are giving us an advice",
        "translation": "Remember, when they are giving us an advice"
    },
    "54": {
        "startTime": 503.25,
        "endTime": 511.41,
        "transcript": "That advice is based on the very basis of their experience, and they want to share that with us.",
        "translation": "That advice is based ont he very basis of their experience, and they want to share that with us."
    },
    "55": {
        "startTime": 511.795,
        "endTime": 515.695,
        "transcript": "We should be thankful for what they have to tell us.",
        "translation": "We should be thankful for what they have to tell us."
    },
    "56": {
        "startTime": 516.06,
        "endTime": 523.55,
        "transcript": "Tayima waten alerquagaqamegtekut ukut ciuliamta",
        "translation": "When our elders instruct us like this"
    },
    "57": {
        "startTime": 526.41,
        "endTime": 532.0,
        "transcript": "Alerqualaraakut ikuuyuryuumiamegtekut.",
        "translation": "They instruct us because they want to help us."
    },
    "58": {
        "startTime": 535.35,
        "endTime": 548.11,
        "transcript": "Alerquagaqamegtekut alerqualaraitkut yuullerteng tangerrluku, allat-llu yuullrat tangerrluku ikayuryugyaaqngamegtekut.",
        "translation": "When they instruct us, they instruct us based on their own life, and based on other's lives because they want to help us."
    },
    "59": {
        "startTime": 553.105,
        "endTime": 554.385,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "60": {
        "startTime": 554.95,
        "endTime": 564.77,
        "transcript": "Ava-i au͡gkut qanellrenka amllenricaaqut, tau͡gaam wangkutnun ayagyuanrulrianun ataurtut.",
        "translation": "What I just had to say wasn't much, but they are connected to us younger people."
    },
    "61": {
        "startTime": 568.275,
        "endTime": 575.545,
        "transcript": "Wangkuta-wa ayagyualriani, ayagyuarturalrianun ataut.",
        "translation": "We young people, they are connected to us young people."
    },
    "62": {
        "startTime": 577.505,
        "endTime": 578.895,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "63": {
        "startTime": 580.195,
        "endTime": 586.715,
        "transcript": "Ciuliarurtellriit-mi wall'u taqnerurtellriit?",
        "translation": "What about those who've become elders or adults?"
    },
    "64": {
        "startTime": 587.47,
        "endTime": 593.05,
        "transcript": "Cauga caliarkaat wall'u ikayuutekaat?",
        "translation": "What is their job, or the way they help?"
    },
    "65": {
        "startTime": 596.375,
        "endTime": 601.405,
        "transcript": "Umyuartequrallemni ellaita-llu ikayuryugngaitkut.",
        "translation": "When I think about it, they can help us too."
    },
    "66": {
        "startTime": 604.925,
        "endTime": 612.585,
        "transcript": "Tayima qanruqu'urqatkut assirciquq.",
        "translation": "If they keep speaking to us, it will be good."
    },
    "67": {
        "startTime": 615.1,
        "endTime": 622.98,
        "transcript": "Qaillun yuuyaramta ayagturallerkaa pitekluku qalaruskatkut assiryartuq.",
        "translation": "If they speak to us about how our lives should go, it would be good."
    },
    "68": {
        "startTime": 625.655,
        "endTime": 627.215,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "69": {
        "startTime": 629.73,
        "endTime": 638.8,
        "transcript": "Qanqainarcetevkenaki camek qanrutaqatkut quyavikaqluki pikumteki assirciquq.",
        "translation": "Without letting them just speak, when they tell us something, it would be good if we thanked them."
    },
    "70": {
        "startTime": 642.48,
        "endTime": 655.16,
        "transcript": "Maa-i alerquutait eliqu'rqumteki piyuumiutait-llu assiryaryugnarquq.",
        "translation": "Now, it would be good if we learned their instructions and their desires."
    },
    "71": {
        "startTime": 657.985,
        "endTime": 668.195,
        "transcript": "Thus far, I have been talking about the responsibilities of those of us who are young, maybe relatively young",
        "translation": "Thus far, I have been talking about the responsibilites of those of us who are young, maybe relatively young"
    },
    "72": {
        "startTime": 668.645,
        "endTime": 675.915,
        "transcript": "And lastly, maybe for those of us who are young in mind, heart, and soul.",
        "translation": "And lastly, maybe for those of us who are young in mind, heart, and soul."
    },
    "73": {
        "startTime": 677.915,
        "endTime": 681.625,
        "transcript": "What about the elderly, or the elders?",
        "translation": "What about the elderly, or the elders?"
    },
    "74": {
        "startTime": 682.825,
        "endTime": 690.325,
        "transcript": "What is their responsibility? Or, better yet, do they have any responsibility?",
        "translation": "What is their responsibility? Or, better yet, do they have any responsibility?"
    },
    "75": {
        "startTime": 691.85,
        "endTime": 702.81,
        "transcript": "Yes, in my very humble opinion, they also have some responsibility to us.",
        "translation": "Yes, in my very humble opinion, they also have some responsibility to us."
    },
    "76": {
        "startTime": 705.575,
        "endTime": 717.385,
        "transcript": "They must speak out as a group about our cultural values",
        "translation": "They must speak out as a group about our cultural values"
    },
    "77": {
        "startTime": 719.095,
        "endTime": 724.295,
        "transcript": "Before what is left of our values is gone.",
        "translation": "Before what is left of our values is gone."
    },
    "78": {
        "startTime": 726.595,
        "endTime": 736.475,
        "transcript": "I believe, again very humbly, that it is the responsibility of our elders",
        "translation": "I believe, again very humbly, that it is the responsibility of our elders"
    },
    "79": {
        "startTime": 737.79,
        "endTime": 743.09,
        "transcript": "To teach us what we must do to continue with our values.",
        "translation": "To teach us what we must do to continue with our values."
    },
    "80": {
        "startTime": 743.415,
        "endTime": 752.535,
        "transcript": "But again, it is the responsibility of those of us who are young, relatively young, and young in mind",
        "translation": "But again, it is the responsibility of those of us who are young, relatively, young, and young in mind"
    },
    "81": {
        "startTime": 754.38,
        "endTime": 761.44,
        "transcript": "To hear and listen what they have to share with us.",
        "translation": "To hear and listen what they have to share with us."
    },
    "82": {
        "startTime": 767.425,
        "endTime": 778.215,
        "transcript": "I think when they're talking about values, Yup'ik values",
        "translation": "I think when they're talking about values, Yup'ik values"
    },
    "83": {
        "startTime": 779.655,
        "endTime": 786.415,
        "transcript": "They're talking about something that sometimes is hard to grab.",
        "translation": "They're talking about something that sometimes is hard to grab."
    },
    "84": {
        "startTime": 788.765,
        "endTime": 801.185,
        "transcript": "Yupiit piciryaraitnek yuut qalartaqata iliini taringesciigatnarqeńgalngurnek qalartelartut, tau͡gken tuancaaqluteng.",
        "translation": "When people speak about Yup'ik traditions, they sometimes say things that we can't seem to understand, yet they're right there."
    },
    "85": {
        "startTime": 810.03,
        "endTime": 820.99,
        "transcript": "Ayagyuanrullemni imumi avani apa'urluma pissuryaramek elitnaullruanga.",
        "translation": "When I was younger back then, my grandfather taught me how to hunt."
    },
    "86": {
        "startTime": 823.035,
        "endTime": 828.865,
        "transcript": "Qaillun angutem yuullerkaanek elitnautullruanga.",
        "translation": "He used to teach me about how a man should live."
    },
    "87": {
        "startTime": 832.085,
        "endTime": 840.705,
        "transcript": "Ayuqucirtuutai ilii tayima aturluku piaqama cakviussiyaaksaitua.",
        "translation": "When I would sometimes adhere to some of his instructions, I wouldn't struggle too much."
    },
    "88": {
        "startTime": 843.02,
        "endTime": 845.4,
        "transcript": "Maurluma-llu",
        "translation": "And my grandmother"
    },
    "89": {
        "startTime": 847.025,
        "endTime": 859.065,
        "transcript": "Tayima qanrucimalartua, maurluma-gguq arnam qaillun yuullerkaanek neviarcaq qalarut'lallrua.",
        "translation": "I am told that my grandmother would speak to a young lady about how a woman should live."
    },
    "90": {
        "startTime": 865.35,
        "endTime": 875.36,
        "transcript": "When I was a young man, one of the things that my grandfather taught me was how to go after game.",
        "translation": "When I was a young man, one of the things that my grandfather taught me was how to go after game."
    },
    "91": {
        "startTime": 878.707,
        "endTime": 889.937,
        "transcript": "I was quite fortunate in that I had that privilege, I had the opportunity to be taught those skills.",
        "translation": "I was quite fortunate in that I had that privelage, I had the opportunity to be taught those skills."
    },
    "92": {
        "startTime": 892.719,
        "endTime": 900.747,
        "transcript": "Whenever I have an opportunity, I try to share that, share what was taught to me.",
        "translation": "Whenever I have an opportunity, I try to share that, share what was taught to me."
    },
    "93": {
        "startTime": 900.824,
        "endTime": 904.904,
        "transcript": "But sometimes I don't. That's my fault",
        "translation": "But sometimes I don't. That's my fault."
    },
    "94": {
        "startTime": 911.121,
        "endTime": 919.142,
        "transcript": "Although I was raised by my parents, I spent a lot of my time with my grandfather.",
        "translation": "Although I was raised by my parents, I spent a lot of my time with my grandfather."
    },
    "95": {
        "startTime": 924.761,
        "endTime": 929.003,
        "transcript": "In looking back, I understand",
        "translation": "In looking back, I understand"
    },
    "96": {
        "startTime": 929.77,
        "endTime": 946.396,
        "transcript": "That my grandmother used to teach values that should be respected and gained by the young ladies on how to be a lady.",
        "translation": "That my grandmother used to teach values that should be respected and gained by the young ladies on how to be a lady."
    },
    "97": {
        "startTime": 960.478,
        "endTime": 969.438,
        "transcript": "Tayima ciuliamta qaillun yuuyaramek qalarutaqa'tkut wall'u elitnauraqatekut",
        "translation": "When our elders speak to us or teach us how to live"
    },
    "98": {
        "startTime": 972.214,
        "endTime": 975.874,
        "transcript": "Quyavikaqluki pikumta assirciquq.",
        "translation": "It would be good if we thanked them."
    },
    "99": {
        "startTime": 982.748,
        "endTime": 992.168,
        "transcript": "Atauciq, atauciumek ciuliamta qanrutetuitkut, tamalkumta-llu nalluvkenaki.",
        "translation": "Our elders tell us one thing, and all of us know them."
    },
    "100": {
        "startTime": 995.108,
        "endTime": 1002.548,
        "transcript": "Yup'ut Yupiit qaneryaramek waten ayuqellriamek qanlartut:",
        "translation": "Our Yup'ik people say a piece of traditional wisdom that's like this:"
    },
    "101": {
        "startTime": 1003.835,
        "endTime": 1011.835,
        "transcript": "Yuk-gguq unguvaqallermini taktaciatun eliqurciquq.",
        "translation": "They say that a person will learn for the length of their life."
    },
    "102": {
        "startTime": 1014.521,
        "endTime": 1016.191,
        "transcript": "Piciuguq.",
        "translation": "It's true."
    },
    "103": {
        "startTime": 1020.201,
        "endTime": 1035.191,
        "transcript": "Qaillun-llu wangkuta yuuyararput, Yupiit-llu piciryarait, Yupiit-llu piyuumiutait piyukumteki",
        "translation": "And if we want our way of life, and Yup'ik traditions, and the things Yupiit desire"
    },
    "104": {
        "startTime": 1036.885,
        "endTime": 1047.463,
        "transcript": "Wangkutnek eliskumta ciuliamteńek wall'u Yuullgutemteńek assirciquq.",
        "translation": "It would be good if we learned by ourselves from our elders or our fellow Yupiit."
    },
    "105": {
        "startTime": 1050.576,
        "endTime": 1060.953,
        "transcript": "What was taught to us by our elders is something that we should be sharing with others.",
        "translation": "What was taught to us by our elders is something that we should be sharing with others."
    },
    "106": {
        "startTime": 1064.81,
        "endTime": 1074.043,
        "transcript": "They taught us values of life, hoping that we're going to be learning something in life.",
        "translation": "They taught us values of life, hoping that we're going to be learning something in life."
    },
    "107": {
        "startTime": 1075.663,
        "endTime": 1087.185,
        "transcript": "I think in turn, we must, we should and must teach the children what was taught to us by our elders.",
        "translation": "I think in turn, we must, we should and must teach the children what was taught to us by our elders."
    },
    "108": {
        "startTime": 1090.647,
        "endTime": 1098.047,
        "transcript": "There is a saying within the Yup'ik society that goes something like this:",
        "translation": "There is a saying within the Yup'ik society that goes something like this:"
    },
    "109": {
        "startTime": 1099.596,
        "endTime": 1106.051,
        "transcript": "\"A person will not stop learning as long as they can breathe.\"",
        "translation": "\"A person will not stop learning as long as they can breathe.\""
    },
    "110": {
        "startTime": 1108.428,
        "endTime": 1119.172,
        "transcript": "This is very true, because as I travel throughout the region, I've been adviced, or given advice by our elders",
        "translation": "This is very true, because as I travel throughout the region, I've been adviced, or given advice by our elders"
    },
    "111": {
        "startTime": 1120.78,
        "endTime": 1130.758,
        "transcript": "And I've learned on a daily basis what our way of life is.",
        "translation": "And I've learned on a daily basis what our way of life is."
    },
    "112": {
        "startTime": 1131.983,
        "endTime": 1138.817,
        "transcript": "I think if we are to continue with Yup'ik values",
        "translation": "I think if we are to continue with Yup'ik values"
    },
    "113": {
        "startTime": 1138.828,
        "endTime": 1150.406,
        "transcript": "We must seek to learn all that we can from our elders, from others",
        "translation": "We must seek to learn all that we can from our elders, from others"
    },
    "114": {
        "startTime": 1152.43,
        "endTime": 1159.386,
        "transcript": "As long as the Creator is generous enough to allow us to continue to breathe.",
        "translation": "As long as the Creator is generous enough to allow us to continue to breathe."
    },
    "115": {
        "startTime": 1160.402,
        "endTime": 1167.513,
        "transcript": "Ava-i au͡gkut qanrutkurallrenka amllenricaaqut.",
        "translation": "There wasn't a lot that I had to say."
    },
    "116": {
        "startTime": 1170.639,
        "endTime": 1177.906,
        "transcript": "Tau͡gaam piyunartacirramtun qalarqu'rtua",
        "translation": "But I've been speaking to the best of my ability"
    },
    "117": {
        "startTime": 1183.229,
        "endTime": 1186.829,
        "transcript": "Cikiutellemnek-wa ciuliamteggun.",
        "translation": "Through the gifts I received from our elders."
    },
    "118": {
        "startTime": 1192.131,
        "endTime": 1201.919,
        "transcript": "Qaillun-wa Yupiit piciryarait piugurluteng piarkaukata",
        "translation": "If Yup'ik culture is to somehow continue"
    },
    "119": {
        "startTime": 1202.163,
        "endTime": 1211.207,
        "transcript": "Tayima ciuliamteńek eliskumta, tua-i-llu elitelput waten ilamteńun qalarutkaqluki.",
        "translation": "If we learn from our elders, then speak about what we learned to those around us."
    },
    "120": {
        "startTime": 1211.213,
        "endTime": 1221.09,
        "transcript": "Tuamta-llu ayagyualrianun qalarutkaqluki pikumteki assirciqsugnarquq.",
        "translation": "Then it would be good if we also spoke about them to young people."
    },
    "121": {
        "startTime": 1222.698,
        "endTime": 1236.843,
        "transcript": "In closing, I would like to say that what I had to say was not very much, however, I did the best that I could under the circumstances.",
        "translation": "In closing, I would like to say that what I had to say was not very much, however, I did the best that I could under the circumstances."
    },
    "122": {
        "startTime": 1237.972,
        "endTime": 1247.105,
        "transcript": "What I shared with you this morning was what was shared with me, or, what I had learned from our elders.",
        "translation": "What I shared with you this morning was what was shared with me, or, what I had learned from our elders."
    },
    "123": {
        "startTime": 1248.475,
        "endTime": 1254.319,
        "transcript": "I would like to take this opportunity to thank the Kuskokwim Community College",
        "translation": "I would like to take this opportunity to thank the Kuskokwim Community College"
    },
    "124": {
        "startTime": 1255.581,
        "endTime": 1269.325,
        "transcript": "For giving me an opportunity to share what little knowledge I have gained from our elders, from others",
        "translation": "For giving me an opportunity to share what little knowledge I have gained from our elders, from others"
    },
    "125": {
        "startTime": 1273.429,
        "endTime": 1279.674,
        "transcript": "Over the last several, over the last couple decades.",
        "translation": "Over the last several, over the last couple decades."
    },
    "126": {
        "startTime": 1280.238,
        "endTime": 1286.201,
        "transcript": "Nangnermek-llu ukut Kuskokwim Community College-aat quyaviksuganka",
        "translation": "And lastly, I want to thank Kuskokwum Community College here"
    },
    "127": {
        "startTime": 1286.215,
        "endTime": 1292.804,
        "transcript": "Waten ilagarluci au͡gkunek-wa tua-i capeqluki",
        "translation": "For being with you here today about what I found difficult"
    },
    "128": {
        "startTime": 1295.857,
        "endTime": 1304.934,
        "transcript": "Caliaqesqellra caperqengramku tayima qalarutkuraranka.",
        "translation": "Through I found it difficult to work with, I spoke about them."
    },
    "129": {
        "startTime": 1304.944,
        "endTime": 1314.611,
        "transcript": "Tau͡gaam cali waten elitellemteńun kinguliamteńun au͡gkunun ayagarkat pitekluki quyavikanka.",
        "translation": "But also, I thank them for this, for the sake of what we learned and our descendants who are going to go."
    },
    "130": {
        "startTime": 1315.693,
        "endTime": 1320.46,
        "transcript": "At this point, I would, I'll turn the show back to...",
        "translation": "At this point, I would, I'll turn the show back to..."
    },
    "131": {
        "startTime": 1325.835,
        "endTime": 1327.102,
        "transcript": "[?] pilii.",
        "translation": "Allow me to [?]."
    },
    "132": {
        "startTime": 1327.118,
        "endTime": 1327.774,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "133": {
        "startTime": 1327.841,
        "endTime": 1329.418,
        "transcript": "Taqsukluten-wa.",
        "translation": "I assume you're done."
    },
    "134": {
        "startTime": 1329.424,
        "endTime": 1330.668,
        "transcript": "Ii-i, taqua.",
        "translation": "Yes, I'm done."
    }
};